import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Remove the loading spinner once React is ready
const removeLoader = () => {
  const loader = document.querySelector('.app-loader');
  if (loader) {
    loader.remove();
  }
};

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// Remove loader after initial render
setTimeout(removeLoader, 0);